import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useWebSocket } from "app/ws/WebSocketProvider"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import PageLayout from "components/layout/PageLayout"
import SeeMyAbsenceWidget from "features/hr/absenceReport/widgets/SeeMyAbsenceWidget"
import SendAbsenceRequestWidget from "features/hr/absenceReport/widgets/SendAbsenceRequestWidget"
import { selectCompanyImg, selectCurrentClaims, selectCurrentUserFirstname } from "../../auth/authSlice"
import HasPermission, { CanManagePatients, CanManageSafetyRequest, CanViewCompanyLog } from "app/PermissionChecker"
import CompanyActivityStats from "features/core/company/components/CompanyActivityStats"
import MyWorkContract from "features/hr/workContract/MyWorkContract"
import NextFeastDay from "features/hr/feastDays/NextFeastDay"
import TopicSubscriber from "app/ws/TopicSubriber"
import SafetyStatsCard from "features/safety/stats/SafetyStatsCard"
import MyHealthWidget from "features/health/widgets/MyHealthWidget"
import { QuickSosWidget } from "features/safety/widgets/QuickSosWidget"
import HealthQuickDashboard from "features/health/widgets/HealthQuickDashboard"

const Home = () => {
    const user = useSelector(selectCurrentUserFirstname)
    const claims = useSelector(selectCurrentClaims)
    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const apiUrl = process.env.REACT_APP_API_URL
    const companyLogoUrl = useSelector(selectCompanyImg)

    console.log("Rendering Welcome...")
    const welcome = t("helper.welcome", { subject: user })

    const { connectionStatus: wsStatus, client: wsClient } = useWebSocket()

    const canAccessActivityStats = HasPermission(CanViewCompanyLog)
    const canViewHealthStats = HasPermission(CanManagePatients)
    const canViewSafetyStats = HasPermission(CanManageSafetyRequest)

    const [messages, setMessages] = useState([])


    const handleStreamPayload = (payload) => {
        // console.log("Home says: " + payload.message.toString()+ " receeived on topic: " + payload.topic)
        setMessages(payload.flat())
    }

    function handlePayload(payload) {
        setMessages(messages => messages.concat(payload))
    }


    const content = (
        <>
            <div className="row mb-4 h-100">
                <div className="col">
                    <p >
                        <span className="text-success">
                            <i className="fa-solid fa-circle-check"></i> {t("helper.valid_session")}<br />
                        </span> {new Date(claims.iat * 1000).toLocaleString()}
                    </p>
                </div>
                <div className="col text-end">
                    {companyLogoUrl && <img width="200" src={`${apiUrl}/file?file=${companyLogoUrl}`} />}

                </div>


            </div>

            {
                canAccessActivityStats &&
                <div className="row">
                    <div className="col">
                        <CompanyActivityStats />
                    </div>

                </div>

            }
            <MyWorkContract />

            {
                canViewHealthStats &&
                <div className="card bg-black bg-opacity-10 text-white mb-4 ">
                    <HealthQuickDashboard />
                </div>
            }

            {
                canViewSafetyStats &&
                <div className="card bg-black bg-opacity-10 text-white mb-4 ">
                    <SafetyStatsCard />
                </div>
            }

            <div className="row mt-4">
                <div className="col mb-2">
                    <h4><i className="fa-solid fa-bolt-lightning"></i> {t("title.quick_actions")}</h4>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-xl-5 d-flex align-items-stretch g-2">
                <QuickSosWidget />
                <MyHealthWidget />
                <SendAbsenceRequestWidget />
                <SeeMyAbsenceWidget />
                <HomeWidgetLayout
                    title={t("absenceReport:menu.next_feast_day")}
                    content={

                        <NextFeastDay />
                    }

                />
                <HomeWidgetLayout
                    title="WebSocket"
                    isSystemWidget={true}
                    content={
                        <>
                            <p><b>clientId:</b><br />  {wsClient != null && wsClient.options.clientId}</p><hr />
                            <p><b>status:</b>  <span className={wsStatus == "Connected" ? "text-success" : "text-danger"}>{wsStatus} </span></p>
                            <p>{
                                messages != null ?
                                    messages.map(message => <li>{JSON.stringify(message.message)} [{message.topic}] </li>) : null}</p>
                        </>
                    }
                />
                <TopicSubscriber
                    subTopic={`test`}
                    onMessageReceived={handlePayload}
                />



            </div>
        </>
    )

    return <PageLayout
        pageTitle={welcome}
        bodyContent={content}
    />
}
export default Home